var map = {
	"./cuiaba/data.json": "+7tN",
	"./default/data.json": "0Pph",
	"./pmvg/data.json": "b1qc",
	"./rondonopolis/data.json": "qXhD",
	"./tce-al/data.json": "TbpH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LhHi";